<template>
  <Toaster
    class="pointer-events-auto"
    position="top-center"
    rich-colors
  />
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
</template>

<script>
import 'vue-sonner/style.css' // vue-sonner v2 requires this import
</script>

<style scoped>
.page-enter-active,
.page-leave-active {
  transition: opacity 0.2s cubic-bezier(0.4, 0, 0.2, 1),
    filter 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.page-enter-from,
.page-leave-to {
  opacity: 0;
  filter: blur(1rem);
}
</style>
